import type { AcademicReportSummary } from "../../services/reportService";
import { byNumber, byText, reversed, type RegisterConfig } from "../register/registerLogic";

export type Learner = AcademicReportSummary["learners"][number];

/** Filters and sorts for the learner performance table on the Reports page. */
export const learnerConfig: RegisterConfig<Learner> = {
  search: (learner) => [learner.name, learner.class_name, learner.division].join(" "),
  views: [
    { key: "all", label: "All" },
    { key: "below", label: "Below 50%", match: (learner) => learner.average_percentage < 50 },
    { key: "above", label: "80% and above", match: (learner) => learner.average_percentage >= 80 },
  ],
  category: { label: "Division", value: (learner) => learner.division },
  sorts: [
    { key: "-average", label: "Average (highest first)", compare: reversed(byNumber<Learner>((learner) => learner.average_percentage)) },
    { key: "average", label: "Average (lowest first)", compare: byNumber<Learner>((learner) => learner.average_percentage) },
    { key: "name", label: "Name (A–Z)", compare: byText<Learner>((learner) => learner.name) },
    { key: "class", label: "Class", compare: (a, b) => a.class_name.localeCompare(b.class_name, undefined, { numeric: true }) || a.name.localeCompare(b.name) },
  ],
};
